import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Link } from "react-router-dom";
import { server } from "../../server";
 
const fetchTransactions = async (sellerId, startDate, endDate) => {
  try {
    const response = await axios.get(`${server}/sellerTransaction/admin/get-transactions/${sellerId}`, {
      params: { startDate, endDate },
      withCredentials: true,
    });

    return response.data.transactions.map((transaction) => ({
      id: transaction._id,
      date: new Date(transaction.transactionDate),
      formattedDate: new Date(transaction.transactionDate).toLocaleDateString(),
      orderId: transaction.orderId ? transaction.orderId : transaction._id,
      credit: transaction.type === "Credit" ? transaction.amount : 0,
      debit: transaction.type === "Debit" ? transaction.amount : 0,
      transactionType: transaction.transactionType,
      referenceNumber: transaction.referenceNumber,
    }));
  } catch (error) {
    console.error("Failed to fetch transactions", error);
    throw error;
  }
};

const ShopAccountTransactions = () => {
  const { seller } = useSelector((state) => state.seller || {});
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState(0);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const fetchAndSetTransactions = useCallback(async () => {
    if (seller._id) {
      try {
        // Fetch all transactions
        const transactions = await fetchTransactions(seller._id, startDate, endDate);

        // Sort transactions by date (most recent first)
        const sortedTransactions = transactions.sort((a, b) => b.date - a.date);

        setTransactions(sortedTransactions);

        const allTransactions = await fetchTransactions(seller._id);

        // Calculate the balance from all transactions
        const calculatedBalance = allTransactions.reduce((acc, transaction) => {
          return acc + (transaction.debit - transaction.credit);
        }, 0);
        setBalance(calculatedBalance.toFixed(2));
      } catch (error) {
        console.error("Failed to fetch transactions", error);
      }
    }
  }, [seller._id, startDate, endDate]);

  useEffect(() => {
    fetchAndSetTransactions();
  }, [fetchAndSetTransactions]);

  return (
    <div style={{ padding: "20px" }}>
      <h1 style={{ textAlign: "center", marginBottom: "20px" }}>Account Transactions</h1>
      <div style={{ textAlign: "right", marginBottom: "20px" }}>
        <h3 style={{ color: '#555' }}>Balance: ₹{balance}</h3>
      </div>

      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '10px',
        backgroundColor: '#f9f9f9',
        borderRadius: '8px',
        boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
        width: 'fit-content',
        marginBottom: '20px'
      }}>
        <label style={{ fontSize: '14px', color: '#555' }}>
          Start Date:
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={{
              marginLeft: '8px',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px'
            }}
          />
        </label>
        <label style={{ fontSize: '14px', color: '#555' }}>
          End Date:
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            style={{
              marginLeft: '8px',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px'
            }}
          />
        </label>
        <button
          onClick={fetchAndSetTransactions}
          style={{
            padding: '8px 12px',
            backgroundColor: '#4CAF50',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
            fontSize: '14px'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#45a049'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#4CAF50'}
        >
          Filter
        </button>
      </div>

      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
          <thead>
            <tr style={{ backgroundColor: "#f2f2f2" }}>
              <th>Date</th>
              <th>Transaction Type</th>
              <th>Order ID / Transaction ID</th>
              <th>Credit</th>
              <th>Debit</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map(transaction => (
              <tr key={transaction.id}>
                <td>{transaction.formattedDate}</td>
                <td>{transaction.transactionType}</td>
                <td>
                  {transaction.transactionType === "Payment recorded" ? (
                    transaction.referenceNumber || "N/A"
                  ) : (transaction.transactionType === "Order received" || transaction.transactionType === "Order cancelled") ? (
                    transaction.orderId !== "N/A" ? (
                      <Link to={`/admin/order/${transaction.orderId}`}>{transaction.orderId}</Link>
                    ) : "N/A"
                  ) : (
                    transaction.referenceNumber || "N/A"
                  )}
                </td>
                <td>{transaction.credit > 0 ? `₹${transaction.credit}` : ""}</td>
                <td>{transaction.debit > 0 ? `₹${transaction.debit}` : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ShopAccountTransactions;

